import { render } from "./FreeDays.vue?vue&type=template&id=735e0225&scoped=true"
import script from "./FreeDays.vue?vue&type=script&lang=js"
export * from "./FreeDays.vue?vue&type=script&lang=js"

import "./FreeDays.vue?vue&type=style&index=0&id=735e0225&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e0225"]])

export default __exports__